import { useRef, useState } from "react";
import { debounce } from "lodash";
import api from "../../api";
import { User } from "../../api/types";

function useSearchUsers(debounceTime = 300) {
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const search = async (query: string) => {
    if (!query.trim()) {
      setUsers([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);


    try {
      const results = await api.searchUsers(query);
      setUsers(results);
    } catch (err) {
      setUsers([]);
    } finally {
      setIsLoading(false);
    }
  };

  const searchUsersRef = useRef(
    debounce((query: string) => {
      search(query);
    }, debounceTime),
  );

  const clearResults = () => {
    setUsers([]);
  };

  return {
    users,
    isLoading,
    searchUsers: searchUsersRef.current,
    clearResults,

  };
}

export default useSearchUsers;
